"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeRoutes = void 0;
var OfficeRoutes;
(function (OfficeRoutes) {
    OfficeRoutes["BasePrefix"] = "offices";
    OfficeRoutes["ById"] = ":officeId";
    OfficeRoutes["All"] = "all";
    OfficeRoutes["List"] = "list";
    OfficeRoutes["Link"] = "link";
    OfficeRoutes["Linked"] = "linked/:officeId";
    OfficeRoutes["LinkedOffice"] = "linked/:linkedOfficeId";
})(OfficeRoutes = exports.OfficeRoutes || (exports.OfficeRoutes = {}));
